import React from "react";
import { AppLayout as AppLayoutLoader, ComponentsProvider } from "@amzn/awsui-app-layout-loader";
import { AppLayoutImplementation } from "./implementation";
import { SplitPanelImplementation } from "../split-panel/implementation";
import { createWidgetizedAppLayout } from "./widget";

const AppLayoutWithProvider = React.forwardRef((props, ref) => {
  return React.createElement(
    ComponentsProvider,
    { getComponentsFallback: () => ({ AppLayout: AppLayoutImplementation, SplitPanel: SplitPanelImplementation }) },
    React.createElement(AppLayoutLoader, { ...props, ref }),
  );
});

export const AppLayoutInternal = createWidgetizedAppLayout(AppLayoutWithProvider);
